import { CAECore } from "@cae/component-library";
import { resource } from "locales/Resource";

import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { loginRequest } from 'Helpers/AuthConfig';


import { App, baseURL } from "Pages";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const Main: React.FC = () => {
  // const { t } = useTranslation("main");
  const { instance } = useMsal();

  const handleLoginRedirect = useCallback((): void => {
    // const redirectStartPage = AppRoutePaths.Home;
    instance.loginPopup({ ...loginRequest })
      .catch((error: Error) => {
        if (error instanceof InteractionRequiredAuthError) {
          console.error("Interaction required:", error.message);
        } else {
          console.error("Login redirect error:", error.message);
        }
      });
  }, [instance]);

  return (
    <CAECore
      appName="SNAI"
      homepage={baseURL}
      resource={resource}
      roleManagement
    >
      <AuthenticatedTemplate>
        <App />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Button variant="contained" onClick={() => handleLoginRedirect()}>
          Login
        </Button>
      </UnauthenticatedTemplate>
    </CAECore>
  );
};

export default Main;
